<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<header>
<h1 class="topictitle1" id="ch5"><a href="#/nav#nch5"><span class="section_number">Chapter 3</span></a></h1>
</header>
<p>Tavish sped backward away from the body, stumbled on the uneven pavers, and landed hard on her backside. The cell in her pocket
            flew out, landing with a <i>crunch </i>on the stone<i>.</i></p>
<p>“No, no, no, no!” She stayed on the ground and put her hand over her mouth to stop the mindless chant.</p>
<p>Marley approached her motionless owner, sniffed, and let out a forlorn howl.</p>
<p>“Oh, Marley . . .” Tavish stood and reached for the dog, then froze. John had been tortured and murdered. She spun, checking
            out the landscape.
         </p>
<p>Nothing moved. Even the wind had died down.</p>
<p>How long had he been lying there? She reluctantly reentered the house and approached the body, her legs trembling, and looked
            again at his face. She gagged. Flies had just discovered him. He hadn’t been dead long. Outside, her phone was in pieces.
            Where was John’s phone?
         </p>
<p>She couldn’t leave Marley to mourn for her master while she dialed the police. After picking up the twenty-five-pound dog,
            she carefully stepped around the body and found John’s landline in the living room to her left. She placed the dog on the
            floor. “Sit. Now stay.” Marley charged from the room, returning to her master.
         </p>
<p>In the living room, the sofa’s cushions were ripped and strewn across the floor. A shattered lamp was underneath the broken
            coffee table. A chair lay on its side in the center of the room with a rope still attached. Bookshelves that had held a few
            ancient Native American artifacts were bare, the contents now a pile of rubble on the floor. Photos of various archaeological
            dig sites were shattered and tossed aside. An empty wall safe stood open in the corner of the room.
         </p>
<p>Tavish bit down on a fingernail, then lifted the handset. No dial tone. She pulled on the phone cord. Cut.</p>
<p>Dizziness overcame her brain. Air was at a premium. Her legs gave way and she dropped to the floor. Blackness lapped around
            her consciousness. “I’m okay, I’m okay,” she gasped. “This will pass. Breathe in calm, breathe out fear.” She ripped off a
            Band-Aid and bit the remains of a nail until the pain pushed back the darkness.
         </p>
<p>She crawled upright and raced to the front door on wobbly legs, snatching up Marley’s leash as she ran past. Leaving the front
            door open, she charged to the car, jumped inside, locked all the doors, then started the engine. She shot down the drive,
            gravel flying. <i>OhLordohLord.</i></p>
<p>She floored the gas, fishtailing onto the road. Her hands shook so hard she could barely grip the steering wheel. Though the
            air conditioner was on high, drops of sweat slithered down her neck. Marley frantically jumped back and forth between the
            front and back seats, barking.
         </p>
<p><i>Wait! There’s a patrol car!</i></p>
<p>A white squad car shot past her on the narrow two-lane road, going the opposite direction. He flew away so quickly she didn’t
            have time to wave him down. She caught a glimpse of a strong jaw and heavy shoulders.
         </p>
<p>Reaching over, she steadied the frantic dog. “It’s going to be okay. We’ll turn around and catch up with him. This road dead-ends
            less than a mile from John’s house, so he can’t be going far.”
         </p>
<p>Marley stopped barking but trembled under her hand.</p>
<p>Her eyes burned. “I’m sorry about John. You know, it’s entirely possible someone else found the body and reported it. That
            would explain the patrol car. If that’s the case, we can simply leave and not get involved.” The road widened and she pulled
            over. Marley gave a husky bark.
         </p>
<p>“What if I’m wrong? No, I can’t leave John’s murdered body where it is.” She sighed and turned the car around. Driving more
            slowly, she checked each house in case the policeman had pulled into one. When she reached John’s driveway, she could see
            the patrol car parked between the landscaped trees. Something about the squad car . . . She squinted, but the angle didn’t
            give her a clear image.
         </p>
<p>“Everything’s fine.” She glanced uneasily in the rearview mirror. “See? Someone <i>did </i>find John and report his murder. We’ll get out of here before that cop notices.” Checking behind her for traffic, she put
            the car into reverse, then glanced at the house.
         </p>
<p>The officer had opened the car’s trunk. He disappeared, then reappeared hauling John’s body over one shoulder. He shoved the
            body inside the trunk, then slammed it shut.
         </p>
<p>Marley barked.</p>
<p>The officer spun toward the gate and stared at Tavish.</p>
<p>She gasped. Her hand flew to her mouth.</p>
<p>He pulled out his service pistol and aimed it at her.</p>
<p>She stomped the gas pedal, spun the wheel, and shot out of the drive. Something pinged her car.</p>
<p>Her heartbeat hammered in her ears. Her shaking hands could barely cling to the steering wheel. <i>He’s shooting at me! Oh my Lord, once he turns around, he’ll catch up with me. I can’t pass out.</i></p>
<p>Marley continued to bark as Tavish floored the gas and looked for another road. All she spotted were the occasional dirt driveways.</p>
<p>Glancing in her rearview mirror, she checked for any sign of the cruiser. She pinched herself hard to keep the panic attack
            at bay.
         </p>
<p>Up ahead was a paved driveway. <i>Good. No telltale dust.</i> She slowed to make the turn. At the end of the lane was an attractive adobe rancher. The drive skirted past the house to
            the right. She followed it around to an open garage. A cobalt-blue pickup was parked on one side. She pulled in next to the
            truck, grabbed Marley, and shoved her to the floor, then ducked down.
         </p>
<p>The dog wiggled under her grasp.</p>
<p>“Shh, please, Marley, I’m sorry, but that man can’t find us,” she whispered. The dog seemed to understand and stilled.</p>
<p>Above her ragged breathing came the unmistakable sound of the garage door closing.</p>
<p>She remained motionless, pressing down on the small dog, and tried to control her chattering teeth. <i>I’m okay, this will pass, breathe in calm, breathe out fear. I’mokay,thiswillpass,breatheincalm,breatheoutfear.</i></p>
<p>Shortly brakes squealed, a car door opened, and male voices carried through an open window. “No, Officer, I haven’t seen a
            white car, but I’ve been watering the plants over there and didn’t notice anyone. Should I be concerned?”
         </p>
<p>“The woman’s wanted for breaking and entering.”</p>
<p>Tavish shivered. Marley licked her hand.</p>
<p>“I’ll keep an eye open. Do you have a card or some way I can call you?”</p>
<p>“No. I . . . uh, I’ll swing back later. Thanks.” A car door slammed and an engine revved, then silence followed. Footsteps.
            A door squealed open nearby. More footsteps.
         </p>
<p>“You can sit up now.”</p>
<p>She jumped, then righted herself.</p>
<p>A thin man about her age stood next to her car. He was wearing jeans, a torn Wisconsin Badgers T-shirt, gardening gloves,
            and a green baseball hat. He smiled, exposing deep dimples. Eyes as cobalt blue as his truck crinkled at the corners. “You
            don’t look like a burglar.”
         </p>
<p>“I’m not—”</p>
<p>“Well then, why was that creepy-looking cop after you?”</p>
<p>“He has a body in the trunk of his car. John Coyote. I saw him put it there.”</p>
<p>The man rocked back on his heels and stared at her for a moment. “That’s not the answer I expected. Maybe you should come
            inside and tell me about it over a glass of iced tea. I’m Kevin, by the way.”
         </p>
<p>“Tavish,” she answered automatically. “I don’t know—”</p>
<p>“I remind you, Tavish, that <i>you</i> pulled into <i>my </i>garage. I hid you from the police. I’m technically your accomplice. The least you can do is tell me more about this body.”
            He glanced at Marley. “And your Rastafarian friend is welcome too.” He nodded toward the door to the house and stood aside
            as she got out with Marley on the end of the leash. Before leaving the garage, she stepped to the rear of her Audi. Her left
            rear bumper sported a neat bullet hole. She licked her suddenly dry lips. <i>Just a few inches higher </i>. . . <i>I’m okay. I’m okay.</i></p>
<p>Inside the house, the decor was vintage 1980s, with pastel blue-and-peach chintz fabrics, tiled countertop, and harvest-gold
            appliances. “Your mom’s house?” Tavish asked.
         </p>
<p>Kevin grinned at her expression. “Yeah. She passed away six months ago. I got here last week to tidy up and put it on the
            market.”
         </p>
<p>“I’m sorry for your loss.”</p>
<p>He shrugged. “It was sudden. She’d remarried and we hadn’t been close for the past couple of years. Have a seat.”</p>
<p>She placed Marley by her feet and sat at a light-colored, faux-wood table in a small dining area off the kitchen. A sliding
            glass door opened to the desert-landscaped backyard. Her gaze kept drifting to the window overlooking the driveway. She folded
            her hands to keep them from shaking and to hide her disastrous fingernails.
         </p>
<p>Kevin poured two glasses of iced tea and placed them on the table, then added a spoon and several packets of sugar. She reached
            for the glass. His gaze lingered on the Band-Aids, but he didn’t ask any questions. He placed a bowl of water next to Marley
            before sitting down. “I’m all ears.”
         </p>
<p>While Marley scooted the water dish across the room with her nose, Tavish told him about the dog’s microchip registered to
            her name, finding John’s body, and her escape. “He was shooting at me. Thank you, by the way, for not turning me in. Why didn’t
            you? You couldn’t have seen the bullet hole.”
         </p>
<p>“The look of terror on your face as you drove in. And that so-called ‘cop’”—Kevin made quotes in the air—“was driving a squad
            car without any law-enforcement marking—just the word <i>sheriff</i> on the side panel.”
         </p>
<p>“That was it! I knew there was something wrong with the car, but didn’t hang around long enough to figure out what.”</p>
<p>“Do you think he’s the one who killed your friend?”</p>
<p>Beads of moisture slid down her glass and puddled on the table. She resisted the urge to bite her nails while she thought.
            “I don’t know. I think he was concealing the murder.”
         </p>
<p>“And the reason your name was registered to your friend’s dog?”</p>
<p>“I don’t know that either.” Her voice rose and she took a sip of tea.</p>
<p>He reached behind him, grabbed some paper towels, and placed them under the glasses. “It sounds like your John Coyote was
            tied up and tortured to get the combination to that safe. I bet he somehow got loose and made a run for it. The thief panicked
            and . . .”
         </p>
<p>Tavish heard a buzzing in her ears and the room dimmed.</p>
<p>“Are you okay? You just turned sheet white.”</p>
<p>She put her head down for a moment. “Just woozy. Give me a minute.”</p>
<p>“I’m sorry. One thing for sure, you’ll need to call the police. A murder, robbery, someone hiding the body and impersonating
            a law-enforcement officer . . .”
         </p>
<p>“The police.” She bit her lip. “Maybe you could call?”</p>
<p>“<i>You’re</i> the one who found the body.”
         </p>
<p>She stood and stepped toward the phone sitting on the counter. He put out his arm to stop her. Marley left her dish and dove
            between them. “You’ll have to find a place where you get cell service. Mom’s landline was disconnected.”
         </p>
<p>She slumped back to her seat. “Which makes this a bigger problem—my cell’s broken. I’ll have to drive somewhere to make that
            call, and he’s out there looking for a white sedan.”
         </p>
<p>“Did he see <i>you</i>?”
         </p>
<p>“I was inside the car, so I’m pretty sure he couldn’t see my face. Not clearly at any rate.”</p>
<p>“You could wait him out. I mean, stay here until dark. He’s got to get rid of that body pretty soon. In this heat . . .”</p>
<p>She clutched the iced-tea glass and tried not to vomit.</p>
<p>“I’m sorry.” Kevin leaned forward. “This John fellow was a friend of yours?”</p>
<p>“He commissioned me for a painting. He is . . . was a very nice man. And I can’t stay here. I have artwork to deliver and
            a gallery opening at four that’s pivotal to my art career. I’ve been working on this for almost year. Oh, what a mess!”
         </p>
<p>“I could drive you straight to the police.”</p>
<p>“No.”</p>
<p>“Cab? Uber?”</p>
<p>“No again. I don’t have the time to get involved in a murder investigation.” She glanced at her watch. “And the last time
            I went to the police about what I thought was a murder . . . they said it was suicide and . . . well . . . I made quite a
            pest of myself and . . .” Her voice caught and she cleared her throat. “I’ll call, but I’ll do it anonymously.”
         </p>
<p>“The police can trace calls. Caller ID and all that. You could send an email. Secret-witness kind of stuff. They have free
            internet access at the library. I’ll give you Mom’s library card.”
         </p>
<p>“That might work. But there’s still the problem of getting out of here.” Silence stretched between them. The old refrigerator
            kicked on, and Marley barked at the noise.
         </p>
<p>“Marley, shush.”</p>
<p>The dog quieted but turned her back on both of them.</p>
<p>“I have an idea.” Kevin sat up straighter. “The pickup in the garage was Mom’s. Take it, go to the library, and email the
            police about the murder. Then take care of your art and go to your opening. When the coast is clear, drive back here and switch
            vehicles.”
         </p>
<p>“That’s generous of you—”</p>
<p>“Hardly generous. I’m loaning you a beater 1978 Chevy pickup and you’re leaving your late-model Audi. But just so you won’t
            think I’m going to steal your car, take the keys when you go.”
         </p>
<p>“That’s very thoughtful, but I’ll leave the keys in case you have to move it. How can I ever thank you?”</p>
<p>He looked away. “Maybe you would . . . um . . . go out with me to dinner or something?”</p>
<p>She stared at him for a moment. There was no way he would be asking her out for her money. How could he know about it? That
            left the way she looked, and she hated it when people took pity on her. She shook her head. “I’m sorry. My life is . . . complicated
            right now.”
         </p>
<p>“That’s okay.” He stood. “Take the truck and bring it back when you can.”</p>
<p>“I wonder if I can ask you for another favor? Do you think you could keep Marley here for a while? I’ll pay you, of course—”</p>
<p>“Sorry. I’m camping out here enough as it is. I don’t have time to take care of a dog. And I’m flying out at the end of the
            week.”
         </p>
<p>“I just thought I’d ask.” She stood.</p>
<p>He stared at her hair. “Even though you don’t think he saw you, maybe you should change your appearance . . .”</p>
<p>She grimaced. “I didn’t think about that.”</p>
<p>“Here.” He handed her his baseball cap, then pulled out a woman’s purse from a cupboard. After rummaging in the black leather
            bag, he lifted out a wallet and removed a library card. “Here. And there’s a pair of sunglasses in the truck. It’s not much . . .”
         </p>
<p>“Thank you.” Her pulse raced as they headed for the garage. She almost forgot to get her artwork out of the Audi. She’d have
            to deliver the pieces to the gallery looking like she had a hangover. What if the killer recognized her in spite of the disguise?
            Maybe she should just stay put. <i>But what if he decides to return and really look for me?</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_3.vue?2572c29e